import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAddons, validateVoicePortingTelephone, validateVoicePortingData } from "../../../../shared/hooks/useFetchServiceDetails";
import API_URLS from "../../Utils/axr";
import store from "../store";
import { PURGE } from "redux-persist";
import { fixAddonForPostpaid, fixAddonForPrepaid } from "../../Utils/util-functions";


interface DefaultVoipObject {
  productFamily: any;
  voipProductSelected?: boolean;
  id?: string;
  productCode?: string;
  productName?: string;
  priceResult?: Array<any>;
  billingRateProductId?: string;
}

interface planDetailsNew { planName: string; effectiveEndDate: string | null; productName: string, planDiscount: string }[] = [];
type getAccordionStateInitialStateType = {
  cartResponse: any;
  selectedAccordion: number;
  voipProducts: any;
  validatePhoneNUmberResponse: any;
  voicePortingData: any;
  voiceRemoved: boolean;
  currentProductData: any;
  baseline: any;
  voipphone: any;
  voipFiberAgreement: any;
  voipServiceLimitationAgreement: boolean;
  voipLnpAgreement: any;
  productFlag: boolean;
  voiceResetted: any;
  isLnpChoosen: string;
  totalDiscountAmount: any;
  planDetailsData: planDetailsNew;
  cartKey: any;
  openBroadband: boolean;
  voiceAdded: any;
  VoipProductName: any;
  cancelVoice: boolean;
  VoipProductPrice: any;
  InstallationProductPrice: any;
  InstallationProductName: any;
  voipProductId: any;
  InternetProductPrice: any;
  InternetProductName: any;
  InternetProductId: any;
  productType: string
  tierKey: string,
  loading: boolean;
  error: any;
  addonsProduct: any;
  discountChangeModalStatus: boolean;
  loosingPlannewSpeedTierModal: boolean;
  nonAffinityPriceLockModal: boolean;
  notEligibleModalStatus: boolean;
  discountName: string;
  discountAmount: any;
  isAffinityFromCatalogue: any;
  currentVoiceProduct: DefaultVoipObject;
  selectedInternetChanged: boolean;
  backToPlan: boolean;
  voipInfo: any;
  sortedVoiceProduct: any;
  speedChanged: any,
  planChangedAction: any;
  internetChangeOrder:any;
  voiceChangeOrder: any;
  vasChangeOrder:any;
  newVoiceOrder:any;
  voicePorted:any;
  orderNumber:any;
  migratedDSLOrder: any;
  oneGfiberProduct: any;
  twoGfiberProduct :any;
  eightGFiberProduct : any;
  vasProductCode:any;
  IQvasProductCode:any;
  parentVasCode:any;
  wifiProductCode:any;
  WHWProductCode:any;
  vasProductPrice: any;
  vasProductName: any;
  vasChecked: boolean;
  vasIqChecked: boolean;
  vasAgreeChecked: boolean;
  existingSpeed: number;
  existingServiceLevel : string;
  voiceLineRemoved: string;
  voiceRemovedLineitemId: string;
  previousCartResponse: any;
  productsOfCart: any;
  vasChangeOrderIQ:boolean;
  vasChangeOrderIQRemove:boolean;
  goToVas:any;
  vasAction:boolean;
  addonsProductLoading: boolean;
  IQVASProductName: string;
  wifiProductName:string;
  WHWProductName:string;
  scheduleAppointment : boolean;
  submitOrderWithTechInstall : boolean;
  addonsTechInstallProduct:any;
  isSelfInstall : boolean;
  wifiCount:any;
  WHW2ProductCode:any;
  WHW3ProductCode:any;
  WHW2ProductName:any;
  WHW3ProductName:any;
  wholeHomeWifiChecked: boolean;
  iqVasProductPrice:any;
  whwProductPrice:any;
  wifiProductPrice:any;
  wifiChangeObject:any;
  needToCallCart:boolean;
  wifiCountPrev:any;
  WHWPackage1:any;
  WHWPackage2:any;
  WHWPackage3:any;
  isDeleteWHW: any;
  isDeleteWIFI: any;
  openDowngrade:any;
  showReturnWiFiModal:any;
  wifiDisplayStatus: any;
  prepaidWifiStatus: any;
}
const initialState: getAccordionStateInitialStateType = {
  selectedAccordion: 1,
  voipProducts: {},
  validatePhoneNUmberResponse: [],
  voicePortingData: null,
  voiceRemoved: false,
  currentProductData: {},
  baseline: {},
  addonsProduct: {},
  voipphone: "",
  voipFiberAgreement: "",
  voipServiceLimitationAgreement: false,
  voipLnpAgreement: '',
  productFlag: false,
  voiceResetted: '',
  isLnpChoosen: "No",
  totalDiscountAmount: '',
  cartKey: '',
  openBroadband: false,
  voiceAdded: false,
  VoipProductName: '',
  cancelVoice: false,
  VoipProductPrice: '',
  InstallationProductPrice: '',
  InstallationProductName: '',
  voipProductId: '',
  InternetProductPrice: '',
  InternetProductName: '',
  InternetProductId: '',
  productType: "",
  tierKey: "",
  loading: false,
  error: null,
  discountChangeModalStatus: false,
  loosingPlannewSpeedTierModal: false,
  nonAffinityPriceLockModal: false,
  notEligibleModalStatus: false,
  discountName: "",
  discountAmount: "",
  isAffinityFromCatalogue: undefined,
  planDetailsData: {
    planName: '',
    effectiveEndDate: '',
    productName: '',
    planDiscount: ''
  },
  currentVoiceProduct: {
    "voipProductSelected": false,
    "id": "",
    "productCode": "",
    "priceResult": [],
    "billingRateProductId": "",
    "productName": "",
    productFamily: "",
  },
  selectedInternetChanged: false,
  backToPlan: false,
  cartResponse: null,
  sortedVoiceProduct: {},
  speedChanged: "",
  planChangedAction: [],
  internetChangeOrder: false,
  voiceChangeOrder: false,
  vasChangeOrder: false,
  newVoiceOrder: false,
  voicePorted: false,
  twoGfiberProduct: false,
  eightGFiberProduct: false,
  oneGfiberProduct: false,
  vasProductCode: undefined,
  IQvasProductCode: undefined,
  parentVasCode: undefined,
  wifiProductCode: undefined,
  wifiCount: undefined,
  WHWProductCode: undefined,
  vasProductPrice: "",
  vasProductName: "",
  vasChecked: false,
  vasIqChecked: false,
  vasAgreeChecked: false,
  orderNumber: "",
  migratedDSLOrder: '',
  voipInfo: {
    earliestCRD: "",
    latestCRD: "",
    lnp: "",
    wirelessPort: "",
    accountHolderName: "",
    accountId: "",
    pinNumber: "",
    agreement: "",
    portAvailablityList: "",
  },
  existingSpeed: 0,
  existingServiceLevel: "",
  voiceLineRemoved: "",
  voiceRemovedLineitemId: "",
  previousCartResponse: undefined,
  productsOfCart: [],
  vasChangeOrderIQ: false,
  vasChangeOrderIQRemove: false,
  goToVas: null,
  vasAction: false,
  addonsProductLoading: false,
  IQVASProductName: "",
  WHWProductName: "",
  wifiProductName: "",
  scheduleAppointment: false,
  submitOrderWithTechInstall: false,
  addonsTechInstallProduct: {},
  isSelfInstall: false,
  WHW2ProductCode:"",
  WHW3ProductCode:"",
  WHW2ProductName:"",
  WHW3ProductName:"",
  wholeHomeWifiChecked: false,
  iqVasProductPrice: "",
  whwProductPrice: "",
  wifiProductPrice: "",
  wifiChangeObject: null,
  needToCallCart: false,
  wifiCountPrev:0,
  WHWPackage1:null,
  WHWPackage2:null,
  WHWPackage3:null,
  isDeleteWHW: false,
  isDeleteWIFI: false,
  openDowngrade:false,
  showReturnWiFiModal:false,
  wifiDisplayStatus:undefined,
  prepaidWifiStatus:undefined
}

export const getAddonProducts = createAsyncThunk(
  "getAddsOnProduct/shopExp",
  async (payload: { addOnsProductsRequest : any; dslMigrationEligible?: boolean,isPostpaid?:boolean,productCode?:any }
) => {
    try {
     const { addOnsProductsRequest, dslMigrationEligible,isPostpaid, productCode} = payload;
     const reduxStore = store.getState();
     let headers = reduxStore?.brightspeedToken?.headers;
     let supplementOrderEligible = reduxStore?.brightSpeedUserUtils?.isSupplementOrderEligible;
     let isMoveSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isMoveSupplementOrderEligible;
     headers = {...headers, flow:"change"};
     const params = {
       "": [API_URLS?.addonsProducts],
     };
     const { sessionId } = reduxStore?.user;
     const user=reduxStore?.user?.data;
     const siteId=reduxStore?.addressQualification?.data?.addressQualification?.entity?.siteId || headers?.siteId;
     const wireCenter =reduxStore?.addressQualification?.data?.addressQualification?.entity?.wireCenter;
     const transactionId=reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId || "brspd-" + headers?.sessionId;
     const channel= process.env.REACT_APP_PLAN_CHANNEL_ID;

      const baseline = {
        transactionId: transactionId,
        channel: dslMigrationEligible ? "web-acm" : channel,
        wirecenter: wireCenter,
        siteId: siteId,
        partnerOrderId: transactionId,
        intent: isMoveSupplementOrderEnabled ? "supplement" : '',
        revisionType: isMoveSupplementOrderEnabled ? "supplement" : "",
        workflow: isMoveSupplementOrderEnabled ? "mover" : supplementOrderEligible ? "buyflow": "change",
        billingType: user?.billingType,
        // ...(supplementOrderEligible && { revisionType: "supplement" }),
        ...(dslMigrationEligible && {
          partnerId: "BS196123",
          salesCode: "20000660",
          partnerReferenceId: "",
          workflow: "migratecoppertofiber",         
        }),
      };

     const payloads = {baseline, addOnsProductsRequest};
     const response = await getAddons(params, payloads, headers);
     const subScriptionPlanDetails = reduxStore?.planDetails?.planDetails;
     return isPostpaid? fixAddonForPostpaid(response.data.addOnsProductResponse,productCode,subScriptionPlanDetails):fixAddonForPrepaid(response.data.addOnsProductResponse,productCode,subScriptionPlanDetails);
    } catch (error) {
     throw(error);
    }
   },
   {
    // Skip only if a request is already in flight (prevents same-tick duplicate dispatches).
    // Explicit refetches (e.g., after cancel voice / plan change) are still allowed.
    condition: (_payload, { getState }) => {
      const state: any = getState();
      const slice = state?.getAccordionStateSlice;
      if (slice?.addonsProductLoading) return false;
      return true;
    },
   }
 );

 export const getAddonProductForTechInstall = createAsyncThunk(
  "getAddonProductForTechInstall/shopExp",
  async (payload: { addOnsProductsRequest : any; dslMigrationEligible?: boolean,isPostpaid?:boolean,productCode?:any }
) => {
    try {
     const { addOnsProductsRequest, dslMigrationEligible,isPostpaid, productCode} = payload;
     const reduxStore = store.getState();
     let headers = reduxStore?.brightspeedToken?.headers;
     headers = {...headers, flow:"change"};
     const params = {
       "": [API_URLS?.addonsProducts],
     };
     const { sessionId } = reduxStore?.user;
     const user=reduxStore?.user?.data;
     const siteId=reduxStore?.addressQualification?.data?.addressQualification?.entity?.siteId || headers?.siteId;
     const wireCenter =reduxStore?.addressQualification?.data?.addressQualification?.entity?.wireCenter;
     const transactionId=reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId || "brspd-" + headers?.sessionId;
     const channel= process.env.REACT_APP_PLAN_CHANNEL_ID;

      const baseline = {
        transactionId: transactionId,
        channel:  channel,
        wirecenter: wireCenter,
        siteId: "bs",
        partnerOrderId: transactionId,
        intent: "",
        workflow: "change",       
      };

     const payloads = {baseline, addOnsProductsRequest};
     const response = await getAddons(params, payloads, headers);
     return isPostpaid? fixAddonForPostpaid(response.data.addOnsProductResponse,productCode):response.data.addOnsProductResponse;
    } catch (error) {
     throw(error);
    }
   }
 );

export const validatePortingTelephone  = createAsyncThunk(
  "validatePhoneNumber/shopExp",
  async (payloadData : any) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const params = {
        "": [API_URLS?.validatePortingTelephone],
      };
      const response = await validateVoicePortingTelephone(params, payloadData, headers);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const validatePortingData  = createAsyncThunk(
  "validatePortData/shopExp",
  async (payloadData : any) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers; 
      let url=API_URLS["voicePortingData"];
      const params = {
        "": [url],
      };
      
      const response = await validateVoicePortingData(params, payloadData, headers);
      const messageStatus = response?.data?.messageStatus?.find((item: any) => {
          if ("statusCode" in item) {
              return item;
          } 
      })
      if (messageStatus?.statusCode == 200) {
          return response?.data;
      } 
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

const getAccordionStateSlice = createSlice({
  name: "getAccordionState/Slice",
  initialState,
  reducers: {
    clearAccordionStateSlice: (state) => {
          return initialState;
    },
    accordionStateSliceSetInitialState: () => initialState,
    getAccordionState: (state, action) => {
      state.selectedAccordion = action.payload;
    },
    selectedPlanType : (state,action: PayloadAction<string>) =>{
      state.productType = action.payload;
    },
    setVoiceRemoved: (state, action: PayloadAction<boolean>) => {
      state.voiceRemoved = action.payload;
    },
    setVoipInfo: (state, action: PayloadAction<any>) => {
      state.voipInfo = {
        ...state.voipInfo,
        ...action.payload}
    },
    setVoipPhone: (state, action: PayloadAction<string>) => {
      state.voipphone = action.payload;
    },
    setVoipFiberAgreement: (state, action: PayloadAction<any>) => {
      state.voipFiberAgreement = action.payload;
    },
    setVoipServiceLimitationAgreement: (state, action: PayloadAction<any>) => {
      state.voipServiceLimitationAgreement = action.payload;
    },
    setVoipLnpAgreement: (state, action: PayloadAction<boolean>) => {
      state.voipLnpAgreement = action.payload;
    },
    setProductFlag: (state, action: PayloadAction<any>) => {
      state.productFlag = action.payload;
    },
    setVoiceResetted: (state, action: PayloadAction<any>) => {
      state.voiceResetted = action.payload;
    },
    setIsLnpChoosen: (state, action: PayloadAction<any>) => {
      state.isLnpChoosen = action.payload;
    },
    setTotalDiscountAmount: (state, action: PayloadAction<any>) => {
      state.totalDiscountAmount = action.payload;
    },
    setPlanDetailsDiscountData: (state, action: PayloadAction<any>) => {
      state.planDetailsData = action.payload;
    },
    setOpenBroadband: (state, action: PayloadAction<any>) => {
      state.openBroadband = action.payload;
    },
    setVoiceAdded: (state, action: PayloadAction<any>) => {
      state.voiceAdded = action.payload;
    },
    setCancelVoice: (state, action: PayloadAction<any>) => {
      state.cancelVoice = action.payload;
    },
    setVoipProductName: (state, action: PayloadAction<any>) => {
      state.VoipProductName = action.payload;
    },
    setVoipProductPrice: (state, action: PayloadAction<any>) => {
      state.VoipProductPrice = action.payload;
    },
    setInstallationProductPrice: (state, action: PayloadAction<any>) => {
      state.InstallationProductPrice = action.payload;
    },
    setInstallationProductName: (state, action: PayloadAction<any>) => {
      state.InstallationProductName = action.payload;
    },
    setVoipProductId: (state, action: PayloadAction<any>) => {
      state.voipProductId = action.payload;
    },
    setInternetProductPrice: (state, action: PayloadAction<any>) => {
      state.InternetProductPrice = action.payload;
    },
    setInternetProductName: (state, action: PayloadAction<any>) => {
      state.InternetProductName = action.payload;
    },
    setInternetProductId: (state, action: PayloadAction<any>) => {
      state.InternetProductId = action.payload;
    },
    setvalidatePhoneNUmberResponse: (state,action:PayloadAction<any>)=>{
      state.validatePhoneNUmberResponse = action.payload
    },
    setvoicePortingData:(state,action:PayloadAction<any>)=>{
      state.voicePortingData = action.payload
    },
    setCurrentProductData: (state,action:PayloadAction<any>)=>{
      state.currentProductData = action.payload
    },
    setCurrentVoiceProduct: (state,action:PayloadAction<any>)=>{
      state.currentVoiceProduct = action.payload
    },
    setDiscountChangedModal:(state,action:PayloadAction<any>)=>{
      state.discountChangeModalStatus = action.payload
    },
    setLoosingPlanNewSpeedTierModal:(state,action:PayloadAction<any>)=>{
      state.loosingPlannewSpeedTierModal = action.payload
    },
    setNonAffinityPriceLockModal: (state, action: PayloadAction<any>) => {
      state.nonAffinityPriceLockModal = action.payload
    },
    setNotEligibleModal:(state,action:PayloadAction<any>)=>{
      state.notEligibleModalStatus = action.payload
    },
    setDiscountAmount:(state,action:PayloadAction<any>)=>{
      state.discountAmount = action.payload
    },
    setDiscountName:(state,action:PayloadAction<any>)=>{
      state.discountName = action.payload
    },
    setIsAffinityFromCatalogue:(state,action:PayloadAction<any>)=>{
      state.isAffinityFromCatalogue = action.payload
    },
    setSelectedInternetChanged:(state,action:PayloadAction<any>)=>{
      state.selectedInternetChanged = action.payload
    },
    setBackToPlanSelection:(state,action:PayloadAction<any>)=>{
      state.backToPlan = action.payload
    },
    setSortedVoiceProduct:(state,action:PayloadAction<any>)=>{
      state.sortedVoiceProduct = action.payload
    },
    setChangedSpeed:(state,action:PayloadAction<any>)=>{
      state.speedChanged = action.payload
    },
    setExistingSpeed:(state,action:PayloadAction<any>)=>{
      state.existingSpeed = action.payload
    },
    setExistingServiceLevel:(state,action:PayloadAction<any>)=>{
      state.existingServiceLevel = action.payload
    },
    setPlanChanged:(state,action:PayloadAction<any>)=>{
      state.planChangedAction = action.payload
    },
    setInternetChangeOrder:(state,action:PayloadAction<any>)=>{
      state.internetChangeOrder = action.payload
    },
    setVoiceChangeOrder:(state,action:PayloadAction<any>)=>{
      state.voiceChangeOrder = action.payload
    },
    setAddonsChangeOrderAdded:(state,action:PayloadAction<any>)=>{
      state.vasChangeOrder = action.payload
    },
    setAddonsChangeOrderAddedIQ:(state,action:PayloadAction<any>)=>{
      state.vasChangeOrderIQ = action.payload
    },
    setAddonsChangeOrderAddedIQRemove:(state,action:PayloadAction<any>)=>{
      state.vasChangeOrderIQRemove = action.payload
    },
    
    setNewVoiceChangeOrder:(state,action:PayloadAction<any>)=>{
      state.newVoiceOrder = action.payload
    },
    setVoicePorted:(state,action:PayloadAction<any>)=>{
      state.voicePorted = action.payload
    },
    setChangeOrderNumber:(state,action:PayloadAction<any>)=>{
      state.orderNumber = action.payload
    },
    setMigratedDSLOrder:(state,action:PayloadAction<any>)=>{
      state.migratedDSLOrder = action.payload
    },
    setTwoGfiberProduct:(state,action:PayloadAction<any>)=>{
      state.twoGfiberProduct = action.payload
    },
    setEightGFiberProduct: (state,action:PayloadAction<any>)=>{
      state.eightGFiberProduct = action.payload
    },
    setoneGfiberProduct:(state,action:PayloadAction<any>)=>{
      state.oneGfiberProduct = action.payload
    },
    setVASProduct:(state,action:PayloadAction<any>)=>{
      state.vasProductCode = action.payload
    },
    setIQVASProduct:(state,action:PayloadAction<any>)=>{
      state.IQvasProductCode = action.payload
    },
    setParentCode:(state,action:PayloadAction<any>)=>{
      state.parentVasCode = action.payload
    },
    setWifiProductCode:(state,action:PayloadAction<any>)=>{
      state.wifiProductCode = action.payload
    },
    setWHWProductCode:(state,action:PayloadAction<any>)=>{
      state.WHWProductCode = action.payload
    },    
    setVASProductPrice:(state,action:PayloadAction<any>)=>{
      state.vasProductPrice = action.payload
    },
    setVASProductName:(state,action:PayloadAction<any>)=>{
      state.vasProductName = action.payload
    },
    setIQVASProductPrice:(state,action:PayloadAction<any>)=>{
      state.iqVasProductPrice = action.payload
    },
    setWifiProductPrice:(state,action:PayloadAction<any>)=>{
      state.wifiProductPrice = action.payload
    },
    setWHWProductPrice:(state,action:PayloadAction<any>)=>{
      state.whwProductPrice = action.payload
    },
    setVASChecked:(state,action:PayloadAction<any>)=>{
      state.vasChecked = action.payload
    },
    setIQChecked:(state,action:PayloadAction<any>)=>{
      state.vasIqChecked = action.payload
    },
    setGotVasSec:(state,action:PayloadAction<any>)=>{
      state.goToVas = action.payload
    },
    SetVasAction:(state,action:PayloadAction<any>)=>{
      state.vasAction = action.payload
    },
    
    setVasAgreeChecked:(state,action:PayloadAction<any>)=>{
      state.vasAgreeChecked = action.payload
    },
    setVoiceLineRemoved(state, action: PayloadAction<any>) {
      state.voiceLineRemoved = action.payload;
    },
    setVoiceRemovedLineItemId(state, action: PayloadAction<any>) {
      state.voiceRemovedLineitemId = action.payload;
    },
    setPreviousCartResponse:(state,action:PayloadAction<any>)=>{
      state.previousCartResponse = action.payload
    },
    setChangePlanData(state, action: PayloadAction<boolean>) {
      state.productsOfCart = action.payload;
    },
    setIQVASProductName:(state,action:PayloadAction<any>)=>{
      state.IQVASProductName = action.payload
    },
    setWifiProductName:(state,action:PayloadAction<any>)=>{
      state.wifiProductName = action.payload
    },
    setWHWProductName:(state,action:PayloadAction<any>)=>{
      state.WHWProductName = action.payload
    },
    setSubmitOrderWithTechInstall: (state, action: PayloadAction<any>) => {
      state.submitOrderWithTechInstall = action.payload
    },
    setScheduleAppointment: (state, action: PayloadAction<any>) => {
      state.scheduleAppointment = action.payload
    },
    setSelfInstall: (state, action: PayloadAction<any>) => {
      state.isSelfInstall = action.payload
    },
    setWifiCount:(state,action:PayloadAction<any>)=>{
      state.wifiCount = action.payload
    },
    
    setOpenDowngrade:(state,action:PayloadAction<any>)=>{
      state.openDowngrade = action.payload
    },
    
    setShowReturnWiFiModal:(state,action:PayloadAction<any>)=>{
      state.showReturnWiFiModal = action.payload
    },
    
    
     setWifiCountPrev:(state,action:PayloadAction<any>)=>{
      state.wifiCountPrev = action.payload
    },
    setPrepaidWHWIFIStatus:(state,action:PayloadAction<any>)=>{
      state.prepaidWifiStatus = action.payload
    },
    setWHWIFIDisplayStatus:(state,action:PayloadAction<any>)=>{
      state.wifiDisplayStatus = action.payload
    },
    
 
     setWHW2ProductCode:(state,action:PayloadAction<any>)=>{
      state.WHW2ProductCode = action.payload
    },
    setWHW2ProductName:(state,action:PayloadAction<any>)=>{
      state.WHW2ProductName = action.payload
    },
     setWHW3ProductCode:(state,action:PayloadAction<any>)=>{
      state.WHW3ProductCode = action.payload
    },
      setWHW3ProductName:(state,action:PayloadAction<any>)=>{
      state.WHW3ProductName = action.payload
    },
     setWholeHomeWifiChecked:(state,action:PayloadAction<any>)=>{
      state.wholeHomeWifiChecked = action.payload
    },
    setWifiObjectStatus:(state,action:PayloadAction<any>)=>{
      state.wifiChangeObject = action.payload
    },
    setNeedtoCallCart:(state,action:PayloadAction<any>)=>{
      state.needToCallCart = action.payload
    },
     saveWHWPackage1:(state,action:PayloadAction<any>)=>{
      state.WHWPackage1 = action.payload
    },
     saveWHWPackage2:(state,action:PayloadAction<any>)=>{
      state.WHWPackage2 = action.payload
    },
     saveWHWPackage3:(state,action:PayloadAction<any>)=>{
      state.WHWPackage3 = action.payload
    },
     setDeleteWIFIExtender:(state,action:PayloadAction<any>)=>{
      state.isDeleteWIFI = action.payload
    },
     setDeleteWHW:(state,action:PayloadAction<any>)=>{
      state.isDeleteWHW = action.payload
    },
 
    },
  extraReducers: (builder) => {
   
    builder.addCase(validatePortingTelephone.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(validatePortingTelephone.fulfilled, (state, action) => {
      state.validatePhoneNUmberResponse = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(validatePortingTelephone.rejected, (state, action) => {
      state.validatePhoneNUmberResponse = null;
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(validatePortingData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(validatePortingData.fulfilled, (state, action) => {
      state.voicePortingData = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(validatePortingData.rejected, (state, action) => {
      state.voicePortingData = null;
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(getAddonProducts.pending, (state) => {
      state.addonsProductLoading = true;
    });
    builder.addCase(getAddonProducts.fulfilled, (state, action) => {
      state.addonsProduct = action.payload;
      state.addonsProductLoading = false;
      state.error = null;
    });
    builder.addCase(getAddonProducts.rejected, (state, action) => {
      state.addonsProduct = null;
      state.addonsProductLoading = false;
      state.error = action.error;
    });
     builder.addCase(getAddonProductForTechInstall.pending, (state) => {
      state.addonsTechInstallProduct = true;
    });
    builder.addCase(getAddonProductForTechInstall.fulfilled, (state, action) => {
      state.addonsTechInstallProduct = action.payload;
      state.addonsProductLoading = false;
      state.error = null;
    });
    builder.addCase(getAddonProductForTechInstall.rejected, (state, action) => {
      state.addonsTechInstallProduct = null;
      state.addonsProductLoading = false;
      state.error = action.error;
    });
    builder.addCase(PURGE, () => {
      return  initialState;
    })
  },
})

  export const {
    getAccordionState,
    setVoiceRemoved,
    setVoipInfo,
    setVoipPhone,
    setVoipFiberAgreement,
    setVoipServiceLimitationAgreement,
    setVoipLnpAgreement,
    setProductFlag,
    setVoiceResetted,
    setIsLnpChoosen,
    setOpenBroadband,
    setVoiceAdded,
    setCancelVoice,
    setVoipProductName,
    setVoipProductPrice,
    setInstallationProductPrice,
    setInstallationProductName,
    setVoipProductId,
    setInternetProductPrice,
    setInternetProductName,
    setInternetProductId,
    // baseLine,
    selectedPlanType,
    setCurrentProductData,
    setvalidatePhoneNUmberResponse,
    setvoicePortingData,
    setDiscountChangedModal,
    setLoosingPlanNewSpeedTierModal,
    setNonAffinityPriceLockModal,
    setNotEligibleModal,
    setDiscountAmount,
    setDiscountName,
    setIsAffinityFromCatalogue,
    setCurrentVoiceProduct,
    setSelectedInternetChanged,
    setBackToPlanSelection,
    setSortedVoiceProduct,
    setChangedSpeed,
    setPlanChanged,
    setInternetChangeOrder,
    setVoiceChangeOrder,
    setNewVoiceChangeOrder,
    setAddonsChangeOrderAdded,
    setAddonsChangeOrderAddedIQ,
    setVoicePorted,
    setChangeOrderNumber,
    setMigratedDSLOrder,
    setTwoGfiberProduct,
    setEightGFiberProduct,
    setoneGfiberProduct,
    setVASProduct,
    setIQVASProduct,
    setIQVASProductName,
    setWifiProductCode,
    setWifiProductName,
    setWHWProductCode,
    setWHWProductName,
    setVASProductName,
    setVASProductPrice,
    setVASChecked,
    setIQChecked,
    setVasAgreeChecked,
    setVoiceLineRemoved,
    setVoiceRemovedLineItemId,
    setExistingSpeed,
    setExistingServiceLevel,
    setPreviousCartResponse,
    setChangePlanData,
    setAddonsChangeOrderAddedIQRemove,
    clearAccordionStateSlice,
    accordionStateSliceSetInitialState,
    setGotVasSec,
    setTotalDiscountAmount,
    setPlanDetailsDiscountData,
    SetVasAction,
    setScheduleAppointment,
    setSelfInstall,
    setSubmitOrderWithTechInstall,
    setParentCode,
    setWifiCount,
    setWHW2ProductCode,
    setWHW2ProductName,
    setWHW3ProductCode,
    setWHW3ProductName,
    setWholeHomeWifiChecked,
    setIQVASProductPrice,
    setWifiProductPrice,
    setWHWProductPrice,
    setWifiObjectStatus,
    setNeedtoCallCart,
    setWifiCountPrev,
    saveWHWPackage1,
    saveWHWPackage2,
    saveWHWPackage3,
    setDeleteWIFIExtender,
    setDeleteWHW,
    setOpenDowngrade,
    setShowReturnWiFiModal
  } = getAccordionStateSlice.actions;
  export default getAccordionStateSlice.reducer;
  
  